var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-uppercase intranet-link",staticStyle:{"font-weight":"bold"},attrs:{"to":_vm.link.path,"exact-active-class":"intranet-link-active","active-class":"intranet-link-active"}},[_vm._v(_vm._s(_vm.link.name))])}
var staticRenderFns = []

export { render, staticRenderFns }